import * as $ from "jquery"
import { App } from "../../_app";

//App.Common.Contact
export class Contact {

    static init(): void {
        if (document.getElementById("contact-page") != null) {
            document.getElementById("faqCategory").addEventListener("change", () => {

                const subject = <HTMLInputElement>document.getElementById("subject");
                const infoBox = <HTMLDivElement>document.getElementById("infobox");
                const faqCategory = <HTMLInputElement>document.getElementById("faqCategory");
                if (parseInt(faqCategory.value) === 0) {
                    App.Common.Functions.ShowHide.hide(document.getElementById("contact-main-form"));
                    infoBox.innerHTML = document.getElementById("hide-on-scroll").getAttribute("data-main");
                    subject.value = "";
                } else {
                    const faqCategory = <HTMLSelectElement>document.getElementById("faqCategory");
                    const selectedFaqCategory = faqCategory.options[faqCategory.selectedIndex];
                    const selectedFaqText = selectedFaqCategory.text;
                    const selectedFaqValue = selectedFaqCategory.value;

                    subject.value = selectedFaqCategory.getAttribute("data-german");

                    document.getElementById("contactSelectionChangeStatusHeadline").innerText = selectedFaqText;
                    document.getElementById("contactSelectionChangeStatus").innerText = selectedFaqText
                        + document.getElementById("contactSelectionChangeStatus").getAttribute("data-additional-text");

                    const subjectHolder = <HTMLInputElement>document.getElementById("SubjectHolder");
                    subjectHolder.value = selectedFaqText;

                    $(".faq-screen").hide();
                    $("#faq-subject-" + selectedFaqValue).show();


                    if ($("#startPageLink").is(":visible")) {
                        $(".sent").each(function () {
                            $(this).html($(this).data("original"));
                        });

                        App.Common.Functions.ShowHide.show(document.getElementById("faqPageLink"));
                        App.Common.Functions.ShowHide.hide(document.getElementById("startPageLink"));

                        document.getElementById("error-container").innerHTML = "";
                    }

                    App.Common.Functions.ShowHide.show(document.getElementById("contact-main-form"));
                    
                    infoBox.innerHTML = document.getElementById("hide-on-scroll").getAttribute("data-faq");
                }
            });
        }
    }
}